import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('PriceInfoWrapper')(({ isCompareSection }) => css({
    backgroundColor: 'grey.5',
    p: '10px',
    mt: isCompareSection ? '0' : '40px',
    borderBottom: '1px solid',
    borderBottomColor: 'grey.3',
    mb: isCompareSection ? ['default', 'default', '40px'] : '0',
}));
export default themeStyles;
